import { render } from "./Pagination.vue?vue&type=template&id=703cd078&scoped=true"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"

import "./Pagination.vue?vue&type=style&index=0&id=703cd078&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-703cd078"

export default script